import React from "react";import { Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import SearchableCustomerSelect from "../../components/Common/SearchableCustomerSelect ";

const Filter = ({
  setOpenMenu,
  openMenu,
  onSubmit,
  startDate,
  endDate,
  setDateRange,
  setCustomer,
  customer,
  paymentStatus,
  setPaymentStatus,
  isFilterActive,
  handleClearFilter
}) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="filter cm-content-box box-primary">
          <div
            className="content-title SlideToolHeader"
            onClick={() => setOpenMenu(!openMenu)}
          >
            <div className="cpa">
              <i className="fa-sharp fa-solid fa-filter me-2" />
              Filter
            </div>
            <div className="tools">
              <Link
                to={"#"}
                className={`handle ${openMenu ? "expand" : "collpase"}`}
              >
                <i className="fal fa-angle-down" />
              </Link>
            </div>
          </div>
          <Collapse in={openMenu}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="mb-3 col-lg-3 col-md-6">
                    {/* <h6 className="title">Date Range</h6> */}
                    <div className="input-group">
                      <DateRangePicker
                        initialSettings={{
                          ...(startDate ? { startDate } : {}),
                          ...(endDate ? { endDate } : {}),
                          locale: {
                            format: "DD/MM/YYYY",
                          },
                        }}
                        onApply={(event, picker) => {
                          setDateRange({
                            startDate: picker.startDate,
                            endDate: picker.endDate,
                          });
                        }}
                      >
                        <input
                          type="text"
                          className="form-control input-daterange-timepicker"
                          placeholder="Select date range"
                          readOnly
                          value={
                            startDate && endDate
                              ? `${startDate.format(
                                  "DD/MM/YYYY"
                                )} - ${endDate.format("DD/MM/YYYY")}`
                              : ""
                          }
                        />
                      </DateRangePicker>
                      {startDate && endDate && (
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          style={{ marginLeft: 4 }}
                          title="Clear date range"
                          onClick={() => setDateRange({ startDate: null, endDate: null })}
                        >
                          <i className="fa fa-times" />
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="mb-3 col-lg-3 col-md-6">
                    <SearchableCustomerSelect
                      onSelect={(option) => setCustomer(option?.value)}
                    />
                  </div>
                  <div className="mb-3 col-lg-2 col-md-3">
                    <select
                      className="form-select"
                      value={paymentStatus}
                      onChange={(e) => setPaymentStatus(e.target.value)}
                    >
                      <option value="">All Status</option>
                      <option value="success">Success</option>
                      <option value="pending">Pending</option>
                      <option value="failed">Failed</option>
                    </select>
                  </div>
                  <div className="col-lg-2 col-md-3 align-self-end mb-3">
                    <button
                      onClick={onSubmit}
                      className="btn btn-primary rounded-sm w-100"
                      title="Click here to Search"
                      type="button"
                    >
                      <i className="fa fa-search me-1" />
                      Search
                    </button>
                  </div>
                  <div className="col-lg-2 col-md-3 align-self-end mb-3">
                    <button
                      className="btn rounded-sm w-100"
                      style={{
                        background: isFilterActive ? '#dc3545' : '#f1f3f6',
                        color: isFilterActive ? '#fff' : '#6c757d',
                        border: isFilterActive ? '1px solid #dc3545' : '1px solid #d1d5db',
                        padding: '8px 16px',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s ease-in-out'
                      }}
                      disabled={!isFilterActive}
                      onClick={handleClearFilter}
                      title="Clear all filters"
                      type="button"
                    >
                      <i className="fa fa-times me-1" /> Clear Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default Filter;
